import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import PhoneForm from '@gamiphy/loyalty-station-desktop/components/cashback/cashbackProgram/verification/PhoneForm';
import ConfirmPhone from '@gamiphy/loyalty-station-desktop/components/cashback/cashbackProgram/verification/ConfirmPhone';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';
import { OtpForm } from '@gamiphy/loyalty/loyaltyPage/components/cashbackProgram/verification/otp';
import { UserApi } from '@gamiphy/gamix-modules/user';

const NotVerified: React.FC<{
  onDone?: () => void,
  description?: React.ReactNode,
}> = ({
  onDone,
  description,
}) => {
  const [phone, setPhone] = React.useState<string>();
  const [userCheckedPhone, setUserCheckedPhone] = React.useState(false);

  const content = React.useMemo(() => {
    if (!phone) {
      if (UserStore.user?.unverifiedPhone && !userCheckedPhone) {
        return (
          <ConfirmPhone
            unverifiedPhone={UserStore.user.unverifiedPhone}
            onEdit={() => setUserCheckedPhone(true)}
            buttonsDirection="column"
            onDone={(newPhone) => {
              setUserCheckedPhone(true);
              setPhone(newPhone);
            }}
          />
        );
      }
      return <PhoneForm onDone={(newPhone) => setPhone(newPhone)} />;
    }
    return (
      <OtpForm
        onDone={onDone}
        onEditPhone={() => setPhone(undefined)}
        phone={phone}
        height={45}
        fontSize={27}
        fullWidthButtons
        verifyPhone={async (newPhone, otp) => { await UserStore.verifyPhone(newPhone, otp); }}
        resendOtp={async (newPhone) => { await UserApi.resendPhoneOtp(newPhone); }}
        fetchDiscounts={async () => { await DiscountsStore.getDiscounts(); }}
        buttonsDirection="column"
      />
    );
  }, [phone, onDone, UserStore.user, userCheckedPhone]);

  return (
    <Box>
      {description && (
        <Typography fontSize={14} fontWeight={400} mb={1.5}>
          {description}
        </Typography>
      )}
      {content}
    </Box>
  );
};

export default observer(NotVerified);
